import { parseCsvStrings } from './formatters';

// The claim login matches when the IdP sends no client claim
export const DEFAULT_CUSTOM_CLAIM_CLIENT = 'default';

// Cleaned the same way as the backend; a blank box means 'default'
export function parseCustomClaimClients(raw: string): string[] {
  const clients = parseCsvStrings(raw).map((client) => (
    client.toLowerCase() === DEFAULT_CUSTOM_CLAIM_CLIENT ? DEFAULT_CUSTOM_CLAIM_CLIENT : client
  ));
  const uniqueClients = [...new Set(clients)];
  return uniqueClients.length > 0 ? uniqueClients : [DEFAULT_CUSTOM_CLAIM_CLIENT];
}

// The inverse of parseCustomClaimClients, so an organisation on 'default' shows an empty box
export function formatCustomClaimClients(clients: string[]): string {
  return clients.length === 1 && clients[0] === DEFAULT_CUSTOM_CLAIM_CLIENT ? '' : clients.join(', ');
}

// Only covers this organisation's names; the backend also checks other organisations on the same SSO configuration
export function getCustomClaimClientsError(clients: string[]): string | null {
  return clients.length > 1 && clients.includes(DEFAULT_CUSTOM_CLAIM_CLIENT)
    ? `'${DEFAULT_CUSTOM_CLAIM_CLIENT}' can't be combined with other custom client names.`
    : null;
}
